import { useHttp } from '../http'

export const useMainGoalHttp = () => {

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get('main-goals', payload)
    }

    const find = <T>(id: number, payload?: any): Promise<T> => {
        return useHttp().get(`main-goals/${id}`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`main-goals/${id}`)
    }

    return {
        get,
        find,
        del,
    }
}
